"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facebook = exports.Eye = exports.EyeUncrossed = exports.EyeCrossed = exports.Expand = exports.Envelope = exports.EllipsisVertical = exports.Elipsis = exports.ElipsisMore = exports.ElipsisAlt = exports.Drums = exports.Download = exports.Download2 = exports.DoubleSharpBold = exports.DoorExit = exports.DocumentPages = exports.DocumentBullets = exports.DocumentBadge = exports.CloseIcon = exports.Circle = exports.CircleFill = exports.ChordDiagram = exports.Check = exports.CheckCircle = exports.CheckCircleFill = exports.Chat = exports.Cart = exports.CartLight = exports.Calendar = exports.Cable = exports.Browse = exports.Box = exports.Book = exports.Bolt = exports.Bolt45C = exports.BadgeCheck = exports.Articles = exports.ArticlesFilled = exports.ArrowUp = exports.ArrowRight = exports.ArrowRightCircle = exports.ArrowLeft = exports.ArrowIndicator = exports.ArrowDown = exports.ArrowActiveLesson = exports.Apple = exports.AppSwitcher = exports.Amp = exports.Alert = exports.Alarm = void 0;
exports.MyFavorites = exports.MinusLight = exports.MinusCircle = exports.Microphone = exports.Metronome = exports.MetronomeRounded = exports.MeshCircle = exports.Menu = exports.Megaphone = exports.MegaphoneFill = exports.MapPin = exports.Logo = exports.LogoTuneHorizontal = exports.LogoToneHorizontal = exports.LogoShopHorizontal = exports.LogoPlayHorizontal = exports.LogoPlayHorizontalIcon = exports.LogoAdminHorizontal = exports.Lock = exports.List = exports.LightningBolt = exports.LifePreserver = exports.Layout = exports.Instagram = exports.InfoCircle = exports.InfoCircleFill = exports.IconError = exports.IconErrorFill = exports.Home = exports.HomeFilled = exports.Heart = exports.HeartFill = exports.HeartBold = exports.HeartBoldFill = exports.Headstock = exports.HeadstockUkuleleTeleFill = exports.HeadstockUkuleleFill = exports.HeadstockFill = exports.HeadstockFillBass = exports.HeadstockFill45C = exports.HeadstockAcousticFill = exports.Headstock45C = exports.GuitarCase = exports.Google = exports.FreemiumCheckMark = exports.Flat = exports.FlatBold = exports.Flame = exports.FirmwareAmp = exports.Filter = void 0;
exports.Settings = exports.Search = exports.Ruler = exports.Ruler45C = exports.Replay = exports.QuestionMark = exports.QuestionMarkCircleFill = exports.ProgressArrow = exports.Profile = exports.Printer = exports.PointerUp = exports.PointerUpLight = exports.PointerThickUp = exports.PointerThickRight = exports.PointerThickLeft = exports.PointerThickDown = exports.PointerRight = exports.PointerRightLight = exports.PointerRightCircle = exports.PointerLeft = exports.PointerLeftLight = exports.PointerLeftCircle = exports.PointerDown = exports.PointerDownLight = exports.PlusLight = exports.PlusCircle = exports.Play = exports.PlayPick = exports.PlayLists = exports.PlayListsFill = exports.PlayCircle = exports.Pinterest = exports.Picks = exports.Pick = exports.PickUp = exports.PickRight = exports.PickLeft = exports.Phone = exports.Pencil = exports.Pause = exports.Path = exports.PathFilled = exports.NoteSharp = exports.NoteFlat = exports.NoteDoubleEighth = exports.Neck = exports.NeckCircle45C = exports.Neck45C = exports.MyProgress = exports.MyProgressFilled = void 0;
exports.Icons = exports.Zoom = exports.Youtube = exports.X = exports.XThin = exports.XCircleFill = exports.WoodGrainCircle = exports.Wifi = exports.VideoSplitscreen = exports.VideoFullscreen = exports.VideoExitFullscreen = exports.VideoDetached = exports.User = exports.UserCircle = exports.Twitter = exports.TuningFork = exports.Tumblr = exports.Tube = exports.TriangleUp = exports.TriangleRight = exports.TriangleLeft = exports.TriangleDown = exports.Toolkit = exports.ToolkitFilled = exports.Tiktok = exports.ThumbsUp = exports.Tablature = exports.Sync = exports.Support = exports.Star = exports.StarFill = exports.StarFillHalf = exports.Speed = exports.Speaker = exports.Songs = exports.SongsFilled = exports.Snapchat = exports.Sliders = exports.Skills = exports.SkillsFilled = exports.SignOut = exports.Sharp = exports.SharpBold = exports.Share = void 0;
var Alarm_1 = __importDefault(require("./Alarm"));
exports.Alarm = Alarm_1.default;
var Alert_1 = __importDefault(require("./Alert"));
exports.Alert = Alert_1.default;
var Amp_1 = __importDefault(require("./Amp"));
exports.Amp = Amp_1.default;
var AppSwitcher_1 = __importDefault(require("./AppSwitcher"));
exports.AppSwitcher = AppSwitcher_1.default;
var Apple_1 = __importDefault(require("./Apple"));
exports.Apple = Apple_1.default;
var ArrowActiveLesson_1 = __importDefault(require("./ArrowActiveLesson"));
exports.ArrowActiveLesson = ArrowActiveLesson_1.default;
var ArrowDown_1 = __importDefault(require("./ArrowDown"));
exports.ArrowDown = ArrowDown_1.default;
var ArrowIndicator_1 = __importDefault(require("./ArrowIndicator"));
exports.ArrowIndicator = ArrowIndicator_1.default;
var ArrowLeft_1 = __importDefault(require("./ArrowLeft"));
exports.ArrowLeft = ArrowLeft_1.default;
var ArrowRightCircle_1 = __importDefault(require("./ArrowRightCircle"));
exports.ArrowRightCircle = ArrowRightCircle_1.default;
var ArrowRight_1 = __importDefault(require("./ArrowRight"));
exports.ArrowRight = ArrowRight_1.default;
var ArrowUp_1 = __importDefault(require("./ArrowUp"));
exports.ArrowUp = ArrowUp_1.default;
var ArticlesFilled_1 = __importDefault(require("./ArticlesFilled"));
exports.ArticlesFilled = ArticlesFilled_1.default;
var Articles_1 = __importDefault(require("./Articles"));
exports.Articles = Articles_1.default;
var BadgeCheck_1 = __importDefault(require("./BadgeCheck"));
exports.BadgeCheck = BadgeCheck_1.default;
var Bolt45C_1 = __importDefault(require("./Bolt45C"));
exports.Bolt45C = Bolt45C_1.default;
var Bolt_1 = __importDefault(require("./Bolt"));
exports.Bolt = Bolt_1.default;
var Book_1 = __importDefault(require("./Book"));
exports.Book = Book_1.default;
var Box_1 = __importDefault(require("./Box"));
exports.Box = Box_1.default;
var Browse_1 = __importDefault(require("./Browse"));
exports.Browse = Browse_1.default;
var Cable_1 = __importDefault(require("./Cable"));
exports.Cable = Cable_1.default;
var Calendar_1 = __importDefault(require("./Calendar"));
exports.Calendar = Calendar_1.default;
var CartLight_1 = __importDefault(require("./CartLight"));
exports.CartLight = CartLight_1.default;
var Cart_1 = __importDefault(require("./Cart"));
exports.Cart = Cart_1.default;
var Chat_1 = __importDefault(require("./Chat"));
exports.Chat = Chat_1.default;
var CheckCircleFill_1 = __importDefault(require("./CheckCircleFill"));
exports.CheckCircleFill = CheckCircleFill_1.default;
var CheckCircle_1 = __importDefault(require("./CheckCircle"));
exports.CheckCircle = CheckCircle_1.default;
var Check_1 = __importDefault(require("./Check"));
exports.Check = Check_1.default;
var ChordDiagram_1 = __importDefault(require("./ChordDiagram"));
exports.ChordDiagram = ChordDiagram_1.default;
var CircleFill_1 = __importDefault(require("./CircleFill"));
exports.CircleFill = CircleFill_1.default;
var Circle_1 = __importDefault(require("./Circle"));
exports.Circle = Circle_1.default;
var CloseIcon_1 = __importDefault(require("./CloseIcon"));
exports.CloseIcon = CloseIcon_1.default;
var DocumentBadge_1 = __importDefault(require("./DocumentBadge"));
exports.DocumentBadge = DocumentBadge_1.default;
var DocumentBullets_1 = __importDefault(require("./DocumentBullets"));
exports.DocumentBullets = DocumentBullets_1.default;
var DocumentPages_1 = __importDefault(require("./DocumentPages"));
exports.DocumentPages = DocumentPages_1.default;
var DoorExit_1 = __importDefault(require("./DoorExit"));
exports.DoorExit = DoorExit_1.default;
var DoubleSharpBold_1 = __importDefault(require("./DoubleSharpBold"));
exports.DoubleSharpBold = DoubleSharpBold_1.default;
var Download2_1 = __importDefault(require("./Download2"));
exports.Download2 = Download2_1.default;
var Download_1 = __importDefault(require("./Download"));
exports.Download = Download_1.default;
var Drums_1 = __importDefault(require("./Drums"));
exports.Drums = Drums_1.default;
var ElipsisAlt_1 = __importDefault(require("./ElipsisAlt"));
exports.ElipsisAlt = ElipsisAlt_1.default;
var ElipsisMore_1 = __importDefault(require("./ElipsisMore"));
exports.ElipsisMore = ElipsisMore_1.default;
var Elipsis_1 = __importDefault(require("./Elipsis"));
exports.Elipsis = Elipsis_1.default;
var EllipsisVertical_1 = __importDefault(require("./EllipsisVertical"));
exports.EllipsisVertical = EllipsisVertical_1.default;
var Envelope_1 = __importDefault(require("./Envelope"));
exports.Envelope = Envelope_1.default;
var Expand_1 = __importDefault(require("./Expand"));
exports.Expand = Expand_1.default;
var EyeCrossed_1 = __importDefault(require("./EyeCrossed"));
exports.EyeCrossed = EyeCrossed_1.default;
var EyeUncrossed_1 = __importDefault(require("./EyeUncrossed"));
exports.EyeUncrossed = EyeUncrossed_1.default;
var Eye_1 = __importDefault(require("./Eye"));
exports.Eye = Eye_1.default;
var Facebook_1 = __importDefault(require("./Facebook"));
exports.Facebook = Facebook_1.default;
var Filter_1 = __importDefault(require("./Filter"));
exports.Filter = Filter_1.default;
var FirmwareAmp_1 = __importDefault(require("./FirmwareAmp"));
exports.FirmwareAmp = FirmwareAmp_1.default;
var Flame_1 = __importDefault(require("./Flame"));
exports.Flame = Flame_1.default;
var FlatBold_1 = __importDefault(require("./FlatBold"));
exports.FlatBold = FlatBold_1.default;
var Flat_1 = __importDefault(require("./Flat"));
exports.Flat = Flat_1.default;
var FreemiumCheckMark_1 = __importDefault(require("./FreemiumCheckMark"));
exports.FreemiumCheckMark = FreemiumCheckMark_1.default;
var Google_1 = __importDefault(require("./Google"));
exports.Google = Google_1.default;
var GuitarCase_1 = __importDefault(require("./GuitarCase"));
exports.GuitarCase = GuitarCase_1.default;
var Headstock45C_1 = __importDefault(require("./Headstock45C"));
exports.Headstock45C = Headstock45C_1.default;
var HeadstockAcousticFill_1 = __importDefault(require("./HeadstockAcousticFill"));
exports.HeadstockAcousticFill = HeadstockAcousticFill_1.default;
var HeadstockFill45C_1 = __importDefault(require("./HeadstockFill45C"));
exports.HeadstockFill45C = HeadstockFill45C_1.default;
var HeadstockFillBass_1 = __importDefault(require("./HeadstockFillBass"));
exports.HeadstockFillBass = HeadstockFillBass_1.default;
var HeadstockFill_1 = __importDefault(require("./HeadstockFill"));
exports.HeadstockFill = HeadstockFill_1.default;
var HeadstockUkuleleFill_1 = __importDefault(require("./HeadstockUkuleleFill"));
exports.HeadstockUkuleleFill = HeadstockUkuleleFill_1.default;
var HeadstockUkuleleTeleFill_1 = __importDefault(require("./HeadstockUkuleleTeleFill"));
exports.HeadstockUkuleleTeleFill = HeadstockUkuleleTeleFill_1.default;
var Headstock_1 = __importDefault(require("./Headstock"));
exports.Headstock = Headstock_1.default;
var HeartBoldFill_1 = __importDefault(require("./HeartBoldFill"));
exports.HeartBoldFill = HeartBoldFill_1.default;
var HeartBold_1 = __importDefault(require("./HeartBold"));
exports.HeartBold = HeartBold_1.default;
var HeartFill_1 = __importDefault(require("./HeartFill"));
exports.HeartFill = HeartFill_1.default;
var Heart_1 = __importDefault(require("./Heart"));
exports.Heart = Heart_1.default;
var HomeFilled_1 = __importDefault(require("./HomeFilled"));
exports.HomeFilled = HomeFilled_1.default;
var Home_1 = __importDefault(require("./Home"));
exports.Home = Home_1.default;
var IconErrorFill_1 = __importDefault(require("./IconErrorFill"));
exports.IconErrorFill = IconErrorFill_1.default;
var IconError_1 = __importDefault(require("./IconError"));
exports.IconError = IconError_1.default;
var InfoCircleFill_1 = __importDefault(require("./InfoCircleFill"));
exports.InfoCircleFill = InfoCircleFill_1.default;
var InfoCircle_1 = __importDefault(require("./InfoCircle"));
exports.InfoCircle = InfoCircle_1.default;
var Instagram_1 = __importDefault(require("./Instagram"));
exports.Instagram = Instagram_1.default;
var Layout_1 = __importDefault(require("./Layout"));
exports.Layout = Layout_1.default;
var LifePreserver_1 = __importDefault(require("./LifePreserver"));
exports.LifePreserver = LifePreserver_1.default;
var LightningBolt_1 = __importDefault(require("./LightningBolt"));
exports.LightningBolt = LightningBolt_1.default;
var List_1 = __importDefault(require("./List"));
exports.List = List_1.default;
var Lock_1 = __importDefault(require("./Lock"));
exports.Lock = Lock_1.default;
var LogoAdminHorizontal_1 = __importDefault(require("./LogoAdminHorizontal"));
exports.LogoAdminHorizontal = LogoAdminHorizontal_1.default;
var LogoPlayHorizontalIcon_1 = __importDefault(require("./LogoPlayHorizontalIcon"));
exports.LogoPlayHorizontalIcon = LogoPlayHorizontalIcon_1.default;
var LogoPlayHorizontal_1 = __importDefault(require("./LogoPlayHorizontal"));
exports.LogoPlayHorizontal = LogoPlayHorizontal_1.default;
var LogoShopHorizontal_1 = __importDefault(require("./LogoShopHorizontal"));
exports.LogoShopHorizontal = LogoShopHorizontal_1.default;
var LogoToneHorizontal_1 = __importDefault(require("./LogoToneHorizontal"));
exports.LogoToneHorizontal = LogoToneHorizontal_1.default;
var LogoTuneHorizontal_1 = __importDefault(require("./LogoTuneHorizontal"));
exports.LogoTuneHorizontal = LogoTuneHorizontal_1.default;
var Logo_1 = __importDefault(require("./Logo"));
exports.Logo = Logo_1.default;
var MapPin_1 = __importDefault(require("./MapPin"));
exports.MapPin = MapPin_1.default;
var MegaphoneFill_1 = __importDefault(require("./MegaphoneFill"));
exports.MegaphoneFill = MegaphoneFill_1.default;
var Megaphone_1 = __importDefault(require("./Megaphone"));
exports.Megaphone = Megaphone_1.default;
var Menu_1 = __importDefault(require("./Menu"));
exports.Menu = Menu_1.default;
var MeshCircle_1 = __importDefault(require("./MeshCircle"));
exports.MeshCircle = MeshCircle_1.default;
var MetronomeRounded_1 = __importDefault(require("./MetronomeRounded"));
exports.MetronomeRounded = MetronomeRounded_1.default;
var Metronome_1 = __importDefault(require("./Metronome"));
exports.Metronome = Metronome_1.default;
var Microphone_1 = __importDefault(require("./Microphone"));
exports.Microphone = Microphone_1.default;
var MinusCircle_1 = __importDefault(require("./MinusCircle"));
exports.MinusCircle = MinusCircle_1.default;
var MinusLight_1 = __importDefault(require("./MinusLight"));
exports.MinusLight = MinusLight_1.default;
var MyFavorites_1 = __importDefault(require("./MyFavorites"));
exports.MyFavorites = MyFavorites_1.default;
var MyProgressFilled_1 = __importDefault(require("./MyProgressFilled"));
exports.MyProgressFilled = MyProgressFilled_1.default;
var MyProgress_1 = __importDefault(require("./MyProgress"));
exports.MyProgress = MyProgress_1.default;
var Neck45C_1 = __importDefault(require("./Neck45C"));
exports.Neck45C = Neck45C_1.default;
var NeckCircle45C_1 = __importDefault(require("./NeckCircle45C"));
exports.NeckCircle45C = NeckCircle45C_1.default;
var Neck_1 = __importDefault(require("./Neck"));
exports.Neck = Neck_1.default;
var NoteDoubleEighth_1 = __importDefault(require("./NoteDoubleEighth"));
exports.NoteDoubleEighth = NoteDoubleEighth_1.default;
var NoteFlat_1 = __importDefault(require("./NoteFlat"));
exports.NoteFlat = NoteFlat_1.default;
var NoteSharp_1 = __importDefault(require("./NoteSharp"));
exports.NoteSharp = NoteSharp_1.default;
var PathFilled_1 = __importDefault(require("./PathFilled"));
exports.PathFilled = PathFilled_1.default;
var Path_1 = __importDefault(require("./Path"));
exports.Path = Path_1.default;
var Pause_1 = __importDefault(require("./Pause"));
exports.Pause = Pause_1.default;
var Pencil_1 = __importDefault(require("./Pencil"));
exports.Pencil = Pencil_1.default;
var Phone_1 = __importDefault(require("./Phone"));
exports.Phone = Phone_1.default;
var PickLeft_1 = __importDefault(require("./PickLeft"));
exports.PickLeft = PickLeft_1.default;
var PickRight_1 = __importDefault(require("./PickRight"));
exports.PickRight = PickRight_1.default;
var PickUp_1 = __importDefault(require("./PickUp"));
exports.PickUp = PickUp_1.default;
var Pick_1 = __importDefault(require("./Pick"));
exports.Pick = Pick_1.default;
var Picks_1 = __importDefault(require("./Picks"));
exports.Picks = Picks_1.default;
var Pinterest_1 = __importDefault(require("./Pinterest"));
exports.Pinterest = Pinterest_1.default;
var PlayCircle_1 = __importDefault(require("./PlayCircle"));
exports.PlayCircle = PlayCircle_1.default;
var PlayListsFill_1 = __importDefault(require("./PlayListsFill"));
exports.PlayListsFill = PlayListsFill_1.default;
var PlayLists_1 = __importDefault(require("./PlayLists"));
exports.PlayLists = PlayLists_1.default;
var PlayPick_1 = __importDefault(require("./PlayPick"));
exports.PlayPick = PlayPick_1.default;
var Play_1 = __importDefault(require("./Play"));
exports.Play = Play_1.default;
var PlusCircle_1 = __importDefault(require("./PlusCircle"));
exports.PlusCircle = PlusCircle_1.default;
var PlusLight_1 = __importDefault(require("./PlusLight"));
exports.PlusLight = PlusLight_1.default;
var PointerDownLight_1 = __importDefault(require("./PointerDownLight"));
exports.PointerDownLight = PointerDownLight_1.default;
var PointerDown_1 = __importDefault(require("./PointerDown"));
exports.PointerDown = PointerDown_1.default;
var PointerLeftCircle_1 = __importDefault(require("./PointerLeftCircle"));
exports.PointerLeftCircle = PointerLeftCircle_1.default;
var PointerLeftLight_1 = __importDefault(require("./PointerLeftLight"));
exports.PointerLeftLight = PointerLeftLight_1.default;
var PointerLeft_1 = __importDefault(require("./PointerLeft"));
exports.PointerLeft = PointerLeft_1.default;
var PointerRightCircle_1 = __importDefault(require("./PointerRightCircle"));
exports.PointerRightCircle = PointerRightCircle_1.default;
var PointerRightLight_1 = __importDefault(require("./PointerRightLight"));
exports.PointerRightLight = PointerRightLight_1.default;
var PointerRight_1 = __importDefault(require("./PointerRight"));
exports.PointerRight = PointerRight_1.default;
var PointerThickDown_1 = __importDefault(require("./PointerThickDown"));
exports.PointerThickDown = PointerThickDown_1.default;
var PointerThickLeft_1 = __importDefault(require("./PointerThickLeft"));
exports.PointerThickLeft = PointerThickLeft_1.default;
var PointerThickRight_1 = __importDefault(require("./PointerThickRight"));
exports.PointerThickRight = PointerThickRight_1.default;
var PointerThickUp_1 = __importDefault(require("./PointerThickUp"));
exports.PointerThickUp = PointerThickUp_1.default;
var PointerUpLight_1 = __importDefault(require("./PointerUpLight"));
exports.PointerUpLight = PointerUpLight_1.default;
var PointerUp_1 = __importDefault(require("./PointerUp"));
exports.PointerUp = PointerUp_1.default;
var Printer_1 = __importDefault(require("./Printer"));
exports.Printer = Printer_1.default;
var Profile_1 = __importDefault(require("./Profile"));
exports.Profile = Profile_1.default;
var ProgressArrow_1 = __importDefault(require("./ProgressArrow"));
exports.ProgressArrow = ProgressArrow_1.default;
var QuestionMarkCircleFill_1 = __importDefault(require("./QuestionMarkCircleFill"));
exports.QuestionMarkCircleFill = QuestionMarkCircleFill_1.default;
var QuestionMark_1 = __importDefault(require("./QuestionMark"));
exports.QuestionMark = QuestionMark_1.default;
var Replay_1 = __importDefault(require("./Replay"));
exports.Replay = Replay_1.default;
var Ruler45C_1 = __importDefault(require("./Ruler45C"));
exports.Ruler45C = Ruler45C_1.default;
var Ruler_1 = __importDefault(require("./Ruler"));
exports.Ruler = Ruler_1.default;
var Search_1 = __importDefault(require("./Search"));
exports.Search = Search_1.default;
var Settings_1 = __importDefault(require("./Settings"));
exports.Settings = Settings_1.default;
var Share_1 = __importDefault(require("./Share"));
exports.Share = Share_1.default;
var SharpBold_1 = __importDefault(require("./SharpBold"));
exports.SharpBold = SharpBold_1.default;
var Sharp_1 = __importDefault(require("./Sharp"));
exports.Sharp = Sharp_1.default;
var SignOut_1 = __importDefault(require("./SignOut"));
exports.SignOut = SignOut_1.default;
var SkillsFilled_1 = __importDefault(require("./SkillsFilled"));
exports.SkillsFilled = SkillsFilled_1.default;
var Skills_1 = __importDefault(require("./Skills"));
exports.Skills = Skills_1.default;
var Sliders_1 = __importDefault(require("./Sliders"));
exports.Sliders = Sliders_1.default;
var Snapchat_1 = __importDefault(require("./Snapchat"));
exports.Snapchat = Snapchat_1.default;
var SongsFilled_1 = __importDefault(require("./SongsFilled"));
exports.SongsFilled = SongsFilled_1.default;
var Songs_1 = __importDefault(require("./Songs"));
exports.Songs = Songs_1.default;
var Speaker_1 = __importDefault(require("./Speaker"));
exports.Speaker = Speaker_1.default;
var Speed_1 = __importDefault(require("./Speed"));
exports.Speed = Speed_1.default;
var StarFillHalf_1 = __importDefault(require("./StarFillHalf"));
exports.StarFillHalf = StarFillHalf_1.default;
var StarFill_1 = __importDefault(require("./StarFill"));
exports.StarFill = StarFill_1.default;
var Star_1 = __importDefault(require("./Star"));
exports.Star = Star_1.default;
var Support_1 = __importDefault(require("./Support"));
exports.Support = Support_1.default;
var Sync_1 = __importDefault(require("./Sync"));
exports.Sync = Sync_1.default;
var Tablature_1 = __importDefault(require("./Tablature"));
exports.Tablature = Tablature_1.default;
var ThumbsUp_1 = __importDefault(require("./ThumbsUp"));
exports.ThumbsUp = ThumbsUp_1.default;
var Tiktok_1 = __importDefault(require("./Tiktok"));
exports.Tiktok = Tiktok_1.default;
var ToolkitFilled_1 = __importDefault(require("./ToolkitFilled"));
exports.ToolkitFilled = ToolkitFilled_1.default;
var Toolkit_1 = __importDefault(require("./Toolkit"));
exports.Toolkit = Toolkit_1.default;
var TriangleDown_1 = __importDefault(require("./TriangleDown"));
exports.TriangleDown = TriangleDown_1.default;
var TriangleLeft_1 = __importDefault(require("./TriangleLeft"));
exports.TriangleLeft = TriangleLeft_1.default;
var TriangleRight_1 = __importDefault(require("./TriangleRight"));
exports.TriangleRight = TriangleRight_1.default;
var TriangleUp_1 = __importDefault(require("./TriangleUp"));
exports.TriangleUp = TriangleUp_1.default;
var Tube_1 = __importDefault(require("./Tube"));
exports.Tube = Tube_1.default;
var Tumblr_1 = __importDefault(require("./Tumblr"));
exports.Tumblr = Tumblr_1.default;
var TuningFork_1 = __importDefault(require("./TuningFork"));
exports.TuningFork = TuningFork_1.default;
var Twitter_1 = __importDefault(require("./Twitter"));
exports.Twitter = Twitter_1.default;
var UserCircle_1 = __importDefault(require("./UserCircle"));
exports.UserCircle = UserCircle_1.default;
var User_1 = __importDefault(require("./User"));
exports.User = User_1.default;
var VideoDetached_1 = __importDefault(require("./VideoDetached"));
exports.VideoDetached = VideoDetached_1.default;
var VideoExitFullscreen_1 = __importDefault(require("./VideoExitFullscreen"));
exports.VideoExitFullscreen = VideoExitFullscreen_1.default;
var VideoFullscreen_1 = __importDefault(require("./VideoFullscreen"));
exports.VideoFullscreen = VideoFullscreen_1.default;
var VideoSplitscreen_1 = __importDefault(require("./VideoSplitscreen"));
exports.VideoSplitscreen = VideoSplitscreen_1.default;
var Wifi_1 = __importDefault(require("./Wifi"));
exports.Wifi = Wifi_1.default;
var WoodGrainCircle_1 = __importDefault(require("./WoodGrainCircle"));
exports.WoodGrainCircle = WoodGrainCircle_1.default;
var XCircleFill_1 = __importDefault(require("./XCircleFill"));
exports.XCircleFill = XCircleFill_1.default;
var XThin_1 = __importDefault(require("./XThin"));
exports.XThin = XThin_1.default;
var X_1 = __importDefault(require("./X"));
exports.X = X_1.default;
var Youtube_1 = __importDefault(require("./Youtube"));
exports.Youtube = Youtube_1.default;
var Zoom_1 = __importDefault(require("./Zoom"));
exports.Zoom = Zoom_1.default;
exports.Icons = {
    Alarm: Alarm_1.default,
    Alert: Alert_1.default,
    Amp: Amp_1.default,
    AppSwitcher: AppSwitcher_1.default,
    Apple: Apple_1.default,
    ArrowActiveLesson: ArrowActiveLesson_1.default,
    ArrowDown: ArrowDown_1.default,
    ArrowIndicator: ArrowIndicator_1.default,
    ArrowLeft: ArrowLeft_1.default,
    ArrowRightCircle: ArrowRightCircle_1.default,
    ArrowRight: ArrowRight_1.default,
    ArrowUp: ArrowUp_1.default,
    ArticlesFilled: ArticlesFilled_1.default,
    Articles: Articles_1.default,
    BadgeCheck: BadgeCheck_1.default,
    Bolt45C: Bolt45C_1.default,
    Bolt: Bolt_1.default,
    Book: Book_1.default,
    Box: Box_1.default,
    Browse: Browse_1.default,
    Cable: Cable_1.default,
    Calendar: Calendar_1.default,
    CartLight: CartLight_1.default,
    Cart: Cart_1.default,
    Chat: Chat_1.default,
    CheckCircleFill: CheckCircleFill_1.default,
    CheckCircle: CheckCircle_1.default,
    Check: Check_1.default,
    ChordDiagram: ChordDiagram_1.default,
    CircleFill: CircleFill_1.default,
    Circle: Circle_1.default,
    CloseIcon: CloseIcon_1.default,
    DocumentBadge: DocumentBadge_1.default,
    DocumentBullets: DocumentBullets_1.default,
    DocumentPages: DocumentPages_1.default,
    DoorExit: DoorExit_1.default,
    DoubleSharpBold: DoubleSharpBold_1.default,
    Download2: Download2_1.default,
    Download: Download_1.default,
    Drums: Drums_1.default,
    ElipsisAlt: ElipsisAlt_1.default,
    ElipsisMore: ElipsisMore_1.default,
    Elipsis: Elipsis_1.default,
    EllipsisVertical: EllipsisVertical_1.default,
    Envelope: Envelope_1.default,
    Expand: Expand_1.default,
    EyeCrossed: EyeCrossed_1.default,
    EyeUncrossed: EyeUncrossed_1.default,
    Eye: Eye_1.default,
    Facebook: Facebook_1.default,
    Filter: Filter_1.default,
    FirmwareAmp: FirmwareAmp_1.default,
    Flame: Flame_1.default,
    FlatBold: FlatBold_1.default,
    Flat: Flat_1.default,
    FreemiumCheckMark: FreemiumCheckMark_1.default,
    Google: Google_1.default,
    GuitarCase: GuitarCase_1.default,
    Headstock45C: Headstock45C_1.default,
    HeadstockAcousticFill: HeadstockAcousticFill_1.default,
    HeadstockFill45C: HeadstockFill45C_1.default,
    HeadstockFillBass: HeadstockFillBass_1.default,
    HeadstockFill: HeadstockFill_1.default,
    HeadstockUkuleleFill: HeadstockUkuleleFill_1.default,
    HeadstockUkuleleTeleFill: HeadstockUkuleleTeleFill_1.default,
    Headstock: Headstock_1.default,
    HeartBoldFill: HeartBoldFill_1.default,
    HeartBold: HeartBold_1.default,
    HeartFill: HeartFill_1.default,
    Heart: Heart_1.default,
    HomeFilled: HomeFilled_1.default,
    Home: Home_1.default,
    IconErrorFill: IconErrorFill_1.default,
    IconError: IconError_1.default,
    InfoCircleFill: InfoCircleFill_1.default,
    InfoCircle: InfoCircle_1.default,
    Instagram: Instagram_1.default,
    Layout: Layout_1.default,
    LifePreserver: LifePreserver_1.default,
    LightningBolt: LightningBolt_1.default,
    List: List_1.default,
    Lock: Lock_1.default,
    LogoAdminHorizontal: LogoAdminHorizontal_1.default,
    LogoPlayHorizontalIcon: LogoPlayHorizontalIcon_1.default,
    LogoPlayHorizontal: LogoPlayHorizontal_1.default,
    LogoShopHorizontal: LogoShopHorizontal_1.default,
    LogoToneHorizontal: LogoToneHorizontal_1.default,
    LogoTuneHorizontal: LogoTuneHorizontal_1.default,
    Logo: Logo_1.default,
    MapPin: MapPin_1.default,
    MegaphoneFill: MegaphoneFill_1.default,
    Megaphone: Megaphone_1.default,
    Menu: Menu_1.default,
    MeshCircle: MeshCircle_1.default,
    MetronomeRounded: MetronomeRounded_1.default,
    Metronome: Metronome_1.default,
    Microphone: Microphone_1.default,
    MinusCircle: MinusCircle_1.default,
    MinusLight: MinusLight_1.default,
    MyFavorites: MyFavorites_1.default,
    MyProgressFilled: MyProgressFilled_1.default,
    MyProgress: MyProgress_1.default,
    Neck45C: Neck45C_1.default,
    NeckCircle45C: NeckCircle45C_1.default,
    Neck: Neck_1.default,
    NoteDoubleEighth: NoteDoubleEighth_1.default,
    NoteFlat: NoteFlat_1.default,
    NoteSharp: NoteSharp_1.default,
    PathFilled: PathFilled_1.default,
    Path: Path_1.default,
    Pause: Pause_1.default,
    Pencil: Pencil_1.default,
    Phone: Phone_1.default,
    PickLeft: PickLeft_1.default,
    PickRight: PickRight_1.default,
    PickUp: PickUp_1.default,
    Pick: Pick_1.default,
    Picks: Picks_1.default,
    Pinterest: Pinterest_1.default,
    PlayCircle: PlayCircle_1.default,
    PlayListsFill: PlayListsFill_1.default,
    PlayLists: PlayLists_1.default,
    PlayPick: PlayPick_1.default,
    Play: Play_1.default,
    PlusCircle: PlusCircle_1.default,
    PlusLight: PlusLight_1.default,
    PointerDownLight: PointerDownLight_1.default,
    PointerDown: PointerDown_1.default,
    PointerLeftCircle: PointerLeftCircle_1.default,
    PointerLeftLight: PointerLeftLight_1.default,
    PointerLeft: PointerLeft_1.default,
    PointerRightCircle: PointerRightCircle_1.default,
    PointerRightLight: PointerRightLight_1.default,
    PointerRight: PointerRight_1.default,
    PointerThickDown: PointerThickDown_1.default,
    PointerThickLeft: PointerThickLeft_1.default,
    PointerThickRight: PointerThickRight_1.default,
    PointerThickUp: PointerThickUp_1.default,
    PointerUpLight: PointerUpLight_1.default,
    PointerUp: PointerUp_1.default,
    Printer: Printer_1.default,
    Profile: Profile_1.default,
    ProgressArrow: ProgressArrow_1.default,
    QuestionMarkCircleFill: QuestionMarkCircleFill_1.default,
    QuestionMark: QuestionMark_1.default,
    Replay: Replay_1.default,
    Ruler45C: Ruler45C_1.default,
    Ruler: Ruler_1.default,
    Search: Search_1.default,
    Settings: Settings_1.default,
    Share: Share_1.default,
    SharpBold: SharpBold_1.default,
    Sharp: Sharp_1.default,
    SignOut: SignOut_1.default,
    SkillsFilled: SkillsFilled_1.default,
    Skills: Skills_1.default,
    Sliders: Sliders_1.default,
    Snapchat: Snapchat_1.default,
    SongsFilled: SongsFilled_1.default,
    Songs: Songs_1.default,
    Speaker: Speaker_1.default,
    Speed: Speed_1.default,
    StarFillHalf: StarFillHalf_1.default,
    StarFill: StarFill_1.default,
    Star: Star_1.default,
    Support: Support_1.default,
    Sync: Sync_1.default,
    Tablature: Tablature_1.default,
    ThumbsUp: ThumbsUp_1.default,
    Tiktok: Tiktok_1.default,
    ToolkitFilled: ToolkitFilled_1.default,
    Toolkit: Toolkit_1.default,
    TriangleDown: TriangleDown_1.default,
    TriangleLeft: TriangleLeft_1.default,
    TriangleRight: TriangleRight_1.default,
    TriangleUp: TriangleUp_1.default,
    Tube: Tube_1.default,
    Tumblr: Tumblr_1.default,
    TuningFork: TuningFork_1.default,
    Twitter: Twitter_1.default,
    UserCircle: UserCircle_1.default,
    User: User_1.default,
    VideoDetached: VideoDetached_1.default,
    VideoExitFullscreen: VideoExitFullscreen_1.default,
    VideoFullscreen: VideoFullscreen_1.default,
    VideoSplitscreen: VideoSplitscreen_1.default,
    Wifi: Wifi_1.default,
    WoodGrainCircle: WoodGrainCircle_1.default,
    XCircleFill: XCircleFill_1.default,
    XThin: XThin_1.default,
    X: X_1.default,
    Youtube: Youtube_1.default,
    Zoom: Zoom_1.default
};
